// extracted by mini-css-extract-plugin
export var closeButton = "_2p-3";
export var header = "_2p-0";
export var link = "_2p-1";
export var retryButton = "_2p-2";